import { IconType } from "@common/declarations";
import React, { useContext } from "react";
import { RichEditorContext } from "../context";
import MenuButtonBase from "./Base";

const CodeviewButton = () => {
  const context = useContext(RichEditorContext);

  return <MenuButtonBase icon={IconType.Code} isActive={context.isCodeview} onMouseDown={context.toggleCodeview} />;
};
export default CodeviewButton;
